<template>
  <div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <router-link  :to="{path:'/storeDetails',query:{id:storeItem.id}}" class="storeList flex_center" v-for="(storeItem,storeIndex) in storeList" :key="storeIndex">
        <div class="storeList__img"><img :src="storeItem.logo" alt=""></div>
        <div class="storeList__content">
          <div class="flex storeList__line">
            <div>{{storeItem.storename}}</div>
            <!-- <div class="storeList__distance">
              <span class="iconfont icon-loc-s col_00A29A"></span>
              <p>{{distanceNum}}KM</p>
            </div> -->
            <div class="storeList__distance" v-if="storeItem.juli">
              <span class="iconfont icon-loc-s col_00A29A"></span>
              <p >{{storeItem.juli}}</p>
            </div>
          </div>
          <div class="col_999 fs_12 storeList__subtitle">
            <p>地址：{{storeItem.address}}</p>
            <p>电话：{{storeItem.tel}}</p>
          </div>
        </div>
      </router-link>
    </van-list>
  </div>
</template>

<script>
  export default {
    name: "storeList",
    data(){
      return{
        //门店列表
        storeList: [
          // {
          //   img_url: '/static/img/store_img1.png',
          //   name: '柳安堂（坂田店）',
          //   address: '2019-09-11 19:30',
          //   phoneNum: '0755-25466566',
          //   distanceNum: '5'
          // },{
          //   img_url: '/static/img/store_img2.png',
          //   name: '柳安堂（坂田店）',
          //   address: '2019-09-11 19:30',
          //   phoneNum: '0755-25466566',
          //   distanceNum: '5'
          // },{
          //   img_url: '/static/img/store_img2.png',
          //   name: '柳安堂（坂田店）',
          //   address: '2019-09-11 19:30',
          //   phoneNum: '0755-25466566',
          //   distanceNum: '5'
          // }
        ],
        distanceNum:5,
        loading:false,
        finished:true,
        lat:0,
        lng:0,
      }
    },
   
     created(){
       this.get_store();
    },
     methods: {
      onLoad() {
        // 异步更新数据
        // setTimeout(() => {
        //   for (let i = 0; i < 3; i++) {
        //     this.storeList.push(this.storeList[0]);
        //   }
        //   // 加载状态结束
        //   this.loading = false;

        //   // 数据全部加载完成
        //   if (this.storeList.length >= 20) {
        //     this.finished = true;
        //   }
        // }, 500);
      },
      get_store(){
        this.wx.wxgetlocation(result=>{    
          this.axios({
            url: this.api.store.store_list,
            data:{
                'lat':result.latitude,
                'lng':result.longitude,
            }
            }).then((res) => {
              if (res.error === 0) {
                this.storeList  = res.store_data
              }

          })
         },()=>{
           this.axios({
            url: this.api.store.store_list,
            data:{
                'lat':0,
                'lng':0,
            }
            }).then((res) => {
              if (res.error === 0) {
                 this.storeList  = res.store_data
              }

          })
         });
      },
    },
  }
</script>

<style scoped>
  @import '../../../assets/css/store.css';   /*门店样式*/
  .storeList__subtitle{
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/book/store/storeList.vue